import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

function ListEditButtons(props) {
    let user = JSON.parse(localStorage.getItem('user'));
    let isValid = (user.role === "ROLE_ADMINISTRATOR");
    return (
        <Fragment>
            {isValid ?
                <Fragment>
                    <Link to={props.to}>
                        <button type="button" className="btn btn-default btn-sm"><i
                            className="material-icons">create</i></button>
                    </Link>
                    {/*<button type="button" className="btn btn-danger btn-sm" onClick={() => props.deleteHandler(props.id)}><i*/}
                        {/*className="material-icons">clear</i></button>*/}
                </Fragment>
                : <Fragment></Fragment>}
        </Fragment>
    )
}


export default ListEditButtons;


// WEBPACK FOOTER //
// ./src/components/ListEditButtons/ListEditButtons.jsx